module.exports = __webpack_public_path__ + "static/media/9-2.2b12779a.mp3";